import { render, staticRenderFns } from "./MyWishlist.vue?vue&type=template&id=3b857efb&scoped=true&"
import script from "./MyWishlist.vue?vue&type=script&lang=js&"
export * from "./MyWishlist.vue?vue&type=script&lang=js&"
import style0 from "./MyWishlist.vue?vue&type=style&index=0&id=3b857efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b857efb",
  null
  
)

export default component.exports